import Vue from 'vue'
import ElementLocale from 'element-ui/lib/locale'
import enLocale from 'element-ui/lib/locale/lang/en'
import zhLocale from 'element-ui/lib/locale/lang/zh-CN'

const STORAGE_KEY = 'pc_locale'
const COOKIE_KEY = 'pc_locale'
const EXPLICIT_STORAGE_KEY = 'pc_locale_explicit'
const EXPLICIT_COOKIE_KEY = 'pc_locale_explicit'
const DEFAULT_LOCALE = 'en'
const SUPPORTED_LOCALES = ['en', 'zh']
const ZH_REGEXP = /[\u4e00-\u9fa5]/

const exactMessages = {
  '首页': 'Home',
  '商城首页': 'Mall Home',
  '登录': 'Login',
  '英文': 'English',
  '中文': 'Chinese',
  '注册': 'Register',
  '请登录': 'Please log in',
  '登录/注册': 'Login/Register',
  '我的订单': 'My Orders',
  '我的余额': 'My Balance',
  '我的积分': 'My Points',
  '我的信息': 'My Profile',
  '我的头像：': 'Avatar:',
  '我的昵称：': 'Nickname:',
  '我的ID：': 'My ID:',
  '我的密码：': 'Password:',
  '我的收藏': 'My Favorites',
  '我的优惠券': 'My Coupons',
  '地址管理': 'Address Management',
  '预售订单': 'Presale Orders',
  '售后/退款': 'After-sales/Refund',
  '入驻记录': 'Settlement Records',
  '总资产(元)': 'Total Assets (NZ$)',
  '累计充值(元)：': 'Total Recharge (NZ$):',
  '累计消费(元)：': 'Total Spending (NZ$):',
  '账单明细': 'Bill Details',
  '收入明细': 'Income Details',
  '支出明细': 'Expense Details',
  '购买商品': 'Purchase Product',
  '商户入驻': 'Merchant Settlement',
  '资讯信息': 'News',
  '资讯详情': 'News Detail',
  '最新资讯': 'Latest News',
  '物流详情': 'Logistics Detail',
  '退款单详情': 'Refund Detail',
  '退款单物流详情': 'Refund Logistics Detail',
  '热销TOP总榜单': 'Top Selling Ranking',
  '限时秒杀': 'Flash Sale',
  '手机商城': 'Mobile Mall',
  '扫码关注公众号': 'Scan to follow',
  '搜索商品': 'Search products',
  '店内商品搜索': 'Search products in store',
  '搜索': 'Search',
  '购物车': 'Cart',
  '收藏本站': 'Bookmark',
  '由于360浏览器功能限制，请按 Ctrl+D 手动收藏！': 'Due to 360 Browser limitations, please press Ctrl+D to bookmark manually!',
  '您的浏览器不支持,请按 Ctrl+D 手动收藏!': 'Your browser does not support this feature. Please press Ctrl+D to bookmark manually!',
  '账号登录': 'Account Login',
  '快速登录': 'Quick Login',
  '快速登录/注册': 'Quick Login/Register',
  '扫码登录': 'QR Login',
  '请使用微信扫一扫登录': 'Use WeChat to scan and log in',
  '忘记密码': 'Forgot Password',
  '注册账号': 'Create Account',
  '请输入手机号': 'Please enter your phone number',
  '请输入正确的手机号码': 'Please enter a valid phone number',
  '请填写手机号码': 'Please fill in your phone number',
  '请输入手机号123': 'Please enter your phone number',
  '请输入账号': 'Please enter your account',
  '请输入密码': 'Please enter your password',
  '请输入新密码': 'Please enter the new password',
  '请填写密码': 'Please enter your password',
  '请填写新密码': 'Please fill in the new password',
  '请填写新手机号码': 'Please fill in the new phone number',
  '请勾选用户隐私协议': 'Please agree to the user privacy agreement',
  '请输入6-16位字母加数字组合': 'Please enter a 6-16 character password with letters and numbers',
  '两次密码不一致': 'The two passwords do not match',
  '注册成功': 'Registration successful',
  '验证码错误': 'Incorrect verification code',
  '入驻申请': 'Settlement Application',
  '商户名称：': 'Merchant Name:',
  '请输入商户名称': 'Please enter the merchant name',
  '用户姓名：': 'Contact Name:',
  '请输入用户姓名': 'Please enter the contact name',
  '手机号：': 'Phone Number:',
  '请输入您的登录密码': 'Please enter your login password',
  '填写您的新密码': 'Enter your new password',
  '再次输入新密码': 'Enter your new password again',
  '请输入验证码': 'Please enter the verification code',
  '验证码：': 'Verification Code:',
  '图片验证码：': 'Captcha:',
  '获取验证码': 'Get Code',
  '重新获取': 'Resend',
  '剩余': 'Remaining',
  '请填写验证码': 'Please fill in the verification code',
  '请填写图片验证码': 'Please fill in the captcha',
  '输入验证码': 'Enter verification code',
  '填写验证码': 'Enter verification code',
  '请输入图片中的验证码': 'Please enter the captcha',
  '我已阅读并同意': 'I have read and agree to',
  '已阅读并同意': 'I have read and agree to',
  '《入驻协议》': 'Settlement Agreement',
  '入驻协议': 'Settlement Agreement',
  '店铺类型说明': 'Store Type Details',
  '店铺类型：': 'Store Type:',
  '请选择店铺类型': 'Please select a store type',
  '商户分类：': 'Merchant Category:',
  '请选择商户分类': 'Please select a merchant category',
  '营业执照：': 'Business License:',
  '请上传营业执照及行业相关资质证明图片': 'Please upload the business license and relevant qualification images',
  '(图片最多可上传10张， 单张图片不超过2M， 图片格式支持JPG、PNG、JPEG)': '(Up to 10 images, max 2MB each, JPG/PNG/JPEG supported)',
  '按 delete 键可删除': 'Press delete to remove',
  '同意并继续': 'Agree and Continue',
  '我知道了': 'Got It',
  '请勾选并同意入驻协议': 'Please check and agree to the settlement agreement',
  '上传图片只能为jpg/jpeg或png格式': 'Images must be jpg, jpeg, or png format',
  '上传图片大小不能超过2MB': 'Image size cannot exceed 2MB',
  '最多上传10张图片': 'You can upload up to 10 images',
  '长度在 3 到 15 个字符': 'Length must be 3 to 15 characters',
  '长度在 2 到 5 个字符': 'Length must be 2 to 5 characters',
  '已没有更多数据': 'No more data',
  '《用户协议》': 'User Agreement',
  '《隐私政策》': 'Privacy Policy',
  '与': 'and',
  '没有账号？': "Don't have an account?",
  '已有账号？': 'Already have an account?',
  '立即注册': 'Register Now',
  '立即登录': 'Login Now',
  '关闭': 'Close',
  '修改密码': 'Change Password',
  '修改手机号码': 'Change Phone Number',
  '品种齐全，购物轻松': 'Wide selection, easy shopping',
  '多仓直发，极速配送': 'Multi-warehouse dispatch, fast delivery',
  '正品行货，精致服务': 'Authentic products, thoughtful service',
  '天天低价，畅选无忧': 'Low prices every day, shop worry-free',
  '商品信息': 'Product Info',
  '单价': 'Unit Price',
  '数量': 'Quantity',
  '金额': 'Amount',
  '操作': 'Action',
  '全选': 'Select All',
  '合计：': 'Total:',
  '去结算': 'Checkout',
  '继续逛': 'Continue Shopping',
  '排序：': 'Sort:',
  '品牌：': 'Brand:',
  '默认': 'Default',
  '销量': 'Sold',
  '评分': 'Rating',
  '价格': 'Price',
  '多选': 'Multi-select',
  '单选': 'Single-select',
  '其他': 'Other',
  '分': ' pts',
  '清空': 'Clear',
  '确定': 'Confirm',
  '确 定': 'Confirm',
  '取消': 'Cancel',
  '取 消': 'Cancel',
  '查看更多商品': 'View All Products',
  '查看全部商品': 'View All Products',
  '为你': 'For You',
  '为你推荐': 'Recommended For You',
  '诚意推荐': 'Recommended',
  '品质商品': 'Quality Products',
  '精品推荐': 'Recommended Picks',
  '热门榜单': 'Hot Board',
  '首页新品': 'New Arrivals',
  '推荐单品': 'Recommended Picks',
  '严格选品标准，精挑细选3W+最优好货': 'Strict selection standards, 30K+ carefully chosen quality products',
  '进店逛逛': 'Visit Store',
  '店铺推荐': 'Store Picks',
  '店铺评分': 'Store Rating',
  '关注人数': 'Followers',
  '联系电话': 'Phone',
  '店铺资质': 'Store Qualifications',
  '企业营业执照': 'Business License',
  '收藏店铺': 'Follow Store',
  '取消收藏': 'Unfollow',
  '已收藏': 'Collected',
  '收藏': 'Collect',
  '联系客服': 'Contact Service',
  '手机购买': 'Buy on Mobile',
  '产品详情': 'Product Details',
  '商品参数': 'Product Parameters',
  '价格说明': 'Price Details',
  '加入购物车': 'Add to Cart',
  '件起购': ' pcs min',
  '最多': 'Max ',
  '已售罄': 'Sold Out',
  '到货通知': 'Restock Alert',
  '累计评论(': 'Reviews (',
  '暂无商品详情': 'No product details yet',
  '满意': 'Positive',
  '全部(': 'All (',
  '好评(': 'Positive (',
  '中评(': 'Neutral (',
  '差评(': 'Negative (',
  '上一页': 'Previous',
  '下一页': 'Next',
  '销量 ': 'Sold ',
  '领券中心': 'Coupon Center',
  '店铺首页': 'Store Home',
  '全部分类': 'All Categories',
  '领优惠券': 'Claim Coupons',
  '店铺券': 'Store Coupon',
  '商品券': 'Product Coupon',
  '品类券': 'Category Coupon',
  '跨店券': 'Cross-store Coupon',
  '通用券': 'General Coupon',
  '立即领取': 'Claim Now',
  '去使用': 'Use Now',
  '已领取': 'Claimed',
  '店小二：': 'Merchant:',
  '人': ' people',
  '万': 'w',
  '恭喜您，领取成功': 'Coupon claimed successfully',
  '感谢您的参与，祝您购物愉快': 'Thank you and enjoy shopping',
  '更多店铺': 'More Stores',
  '立即使用': 'Use Now',
  '无门槛使用': 'No minimum spend',
  '请输入要搜索的内容': 'Please enter search content',
  '请输入您要购买的数量': 'Please enter the quantity to buy',
  '加入购物车成功': 'Added to cart successfully',
  '领取优惠券成功': 'Coupon claimed successfully',
  '取消收藏成功': 'Unfollowed successfully',
  '收藏成功': 'Collected successfully',
  '首页 >': 'Home >',
  '首页 > ': 'Home > ',
  '首页 ></nuxt-link>': 'Home >',
  '订单详情': 'Order Details',
  '退回商品': 'Return Items',
  '物流公司': 'Logistics Company',
  '请选择物流公司': 'Please select a logistics company',
  '物流单号': 'Tracking Number',
  '请输入物流单号': 'Please enter the tracking number',
  '联系电话：': 'Phone:',
  '请输入联系电话': 'Please enter the phone number',
  '提交申请': 'Submit Request',
  '确认': 'Confirm',
  '全部订单(': 'All Orders (',
  '全部退款': 'All Refunds',
  '处理中': 'Processing',
  '已处理': 'Processed',
  '退款中': 'Refunding',
  '部分退款': 'Partial Refund',
  '查看详情': 'View Details',
  '再次申请': 'Apply Again',
  '删除记录': 'Delete Record',
  '亲，暂无订单信息哟~': 'No order information yet',
  '退款：': 'Refund:',
  '全部发票': 'All Invoices',
  '已开票': 'Issued',
  '未开票': 'Not Issued',
  '发票类型': 'Invoice Type',
  '状态': 'Status',
  '发票详情': 'Invoice Details',
  '发票信息': 'Invoice Information',
  '开票状态：': 'Invoice Status:',
  '开票时间：': 'Issue Time:',
  '申请时间：': 'Application Time:',
  '发票类型：': 'Invoice Type:',
  '发票抬头类型：': 'Invoice Title Type:',
  '单位税号：': 'Tax ID:',
  '发票抬头：': 'Invoice Title:',
  '开户银行：': 'Bank Name:',
  '银行账号：': 'Bank Account:',
  '企业地址：': 'Company Address:',
  '企业电话：': 'Company Phone:',
  '普通发票': 'Normal Invoice',
  '专用发票': 'Special Invoice',
  '个人': 'Personal',
  '企业': 'Company',
  '商品分类': 'Product Categories',
  '商品列表': 'Product List',
  '商品搜索': 'Product Search',
  '分类': 'Categories',
  '广场': 'Plaza',
  '精品': 'Premium',
  '推荐': 'Recommended',
  '客服': 'Service',
  '回到顶部': 'Back to Top',
  '火爆': 'Hot',
  '限时': 'Limited',
  '客服电话': 'Service Phone',
  '在线客服': 'Online Service',
  '分类广场': 'Category Plaza',
  '新品': 'New',
  '秒杀': 'Flash Sale',
  '自营': 'Self operated',
  '券': 'Coupon',
  '亲，该分类暂无商品哟~': 'No products in this category yet',
  '亲，该暂无商品哟~': 'No products yet',
  '亲，暂无商品哟~': 'No products yet',
  '亲，该店铺暂无推荐商品哦~': 'No recommended products in this store yet',
  '亲，暂无商户哟~': 'No merchants yet',
  '亲，暂无可使用优惠券哟~': 'No available coupons yet',
  '抱歉，没有找到您搜索的相关商品~': 'Sorry, no products matched your search',
  '亲，购物车还是空的哟~': 'Your cart is still empty',
  '用户协议与隐私政策': 'User Agreement and Privacy Policy',
  '用户协议': 'User Agreement',
  '隐私政策': 'Privacy Policy',
  '抱歉，您访问的页面出错了': 'Sorry, the page you requested encountered an error',
  '您可能输错了网址，或该网页已被删除、不存在等': 'The URL may be incorrect, or the page may have been removed',
  '加载失败': 'Load Failed',
  '错误的请求': 'Invalid Request',
  '请检查您的配置文件': 'Please check your configuration file',
  '返回首页': 'Back to Home',
  '查看订单': 'View Order',
  '查看物流': 'Track Shipment',
  '收货地址': 'Shipping Address',
  '买家留言': 'Buyer Message',
  '填写内容与商家协商并确认，限150字内~': 'Fill in the content after confirming with the merchant, within 150 characters~',
  '快递配送': 'Express Delivery',
  '免运费': 'Free Shipping',
  '件商品，商品总金额：': ' items, Product Total Amount:',
  '应付总额：': 'Amount Payable:',
  '添加新地址': 'Add Address',
  '设为默认': 'Set as Default',
  '设为默认地址': 'Set as Default Address',
  '默认发送至所提供的电子邮件': 'Send to the provided email by default',
  '添加收货地址': 'Add Shipping Address',
  '显示更多收货地址': 'Show More Addresses',
  '隐藏更多收货地址': 'Hide More Addresses',
  '提交订单': 'Place Order',
  '确认订单': 'Confirm Order',
  '支付方式：': 'Payment Method:',
  '配送方式：': 'Delivery Method:',
  '收货信息：': 'Shipping Info:',
  '买家留言：': 'Buyer Message:',
  '备注说明：': 'Remark:',
  '填写备注信息，100字以内': 'Add a remark within 100 characters',
  '使用优惠券': 'Use Coupon',
  '无可使用优惠券': 'No coupons available',
  '无可使用积分': 'No points available',
  '积分抵扣：': 'Points Deduction:',
  '余额支付': 'Balance Payment',
  '微信支付': 'WeChat Pay',
  '支付宝支付': 'Alipay',
  '银联支付': 'Union Pay',
  '选择以下支付方式': 'Choose a payment method',
  '选择其他支付方式': 'Choose another payment method',
  '立即付款': 'Pay Now',
  '立即支付': 'Pay Now',
  '订单提交成功！去付款咯': 'Order submitted successfully. Proceed to payment',
  '订单提交成功！去付款咯~': 'Order submitted successfully. Proceed to payment~',
  '剩余时间：': 'Time remaining:',
  '订单编号：': 'Order No.:',
  '订单价格：': 'Order Amount:',
  '累计销量': 'Total Sold',
  '商品名称：': 'Product Name:',
  '应付金额：': 'Amount Due:',
  '余额：': 'Balance:',
  '去支付': 'Pay Now',
  '请扫码支付': 'Please scan to pay',
  '扫描二维码支付': 'Scan the QR code to pay',
  '请使用微信扫一扫': 'Use WeChat to scan',
  '请使用银联扫一扫': 'Use Union Pay to scan',
  '请使用POLI扫码付款': 'Use POLI to scan and pay',
  '二维码失效，点击重新获取': 'QR code expired, click to refresh',
  '跳转到支付宝完成付款': 'Open Alipay to complete payment',
  '使用账户余额直接付款': 'Pay directly with account balance',
  '生成二维码后微信扫码付款': 'Generate a QR code and pay with WeChat scan',
  '生成二维码后银联扫码付款': 'Generate a QR code and pay with UnionPay scan',
  '生成二维码后扫码付款': 'Generate a QR code and scan to pay',
  ' 小时 ': ' h ',
  ' 分钟 ': ' m ',
  '秒 ': 's ',
  '支付状态：': 'Payment Status:',
  '订单状态：': 'Order Status:',
  '订单信息': 'Order Information',
  '发票说明': 'Invoice Instructions',
  '预售协议': 'Pre-sale Agreement',
  '平台优惠券': 'Platform Coupons',
  '快递配送': 'Shipping Delivery',
  '虚拟发货': 'Virtual Delivery',
  '增值税电子普通发票': 'Electronic VAT Invoice',
  '增值税专用发票': 'Special VAT Invoice',
  '请填写发票抬头': 'Please fill in the invoice title',
  '请填写邮箱': 'Please fill in the email',
  '请输入正确的邮箱': 'Please enter a valid email',
  '请填写税号': 'Please fill in the tax number',
  '请填写开户行': 'Please fill in the bank name',
  '请填写银行账号': 'Please fill in the bank account',
  '请填写企业地址': 'Please fill in the company address',
  '请填写企业电话': 'Please fill in the company phone',
  '请输入正确的银行账号': 'Please enter a valid bank account',
  '请输入正确的电话号码': 'Please enter a valid phone number',
  '请填写姓名': 'Please fill in the name',
  '请填写正确的手机号码': 'Please fill in a valid phone number',
  '请选择省市区': 'Please select province/city/district',
  '请填写详细地址': 'Please fill in the detailed address',
  '添加成功': 'Added successfully',
  '请添加收货地址': 'Please add a shipping address',
  '请阅读并勾选协议，否则无法进行操作': 'Please read and accept the agreement before proceeding',
  '请填写': 'Please fill in ',
  '请输入正确的': 'Please enter a valid ',
  '请输入收货人姓名': 'Please enter the recipient name',
  '请输入收货人电话': 'Please enter the recipient phone',
  '电话格式不正确': 'Invalid phone number format',
  '付款信息': 'Payment Information',
  '配送信息': 'Delivery Information',
  '发货时间：': 'Ship Time:',
  '发货备注：': 'Shipping Note:',
  '退款信息': 'Refund Information',
  '退款原因': 'Refund Reason',
  '退款金额：': 'Refund Amount:',
  '申请退款': 'Request Refund',
  '热销排行': 'Top Selling Ranking',
  '总榜单': 'Overall Ranking',
  '我要退款(无需退货)': 'Refund Only',
  '我要退货退款': 'Return and Refund',
  '未收到货，或与卖家协商同意不退货只退款': 'Not received, or agreed with seller to refund only',
  '已收到货，需要退还收到的货物': 'Received, need to return the goods',
  '我的发票': 'My Invoices',
  '我的订单': 'My Orders',
  '个人中心': 'Personal Center',
  '账户管理': 'Account Settings',
  '退出登录': 'Log Out'
}

const tokenMessages = [
  ['订单详情', 'Order Details'],
  ['商品详情', 'Product Details'],
  ['商品参数', 'Product Parameters'],
  ['商品分类', 'Product Categories'],
  ['商品信息', 'Product Info'],
  ['商品名称', 'Product Name'],
  ['商品数量', 'Quantity'],
  ['商品评分', 'Product Rating'],
  ['商品券', 'Product Coupon'],
  ['店铺首页', 'Store Home'],
  ['店铺推荐', 'Store Picks'],
  ['店铺评分', 'Store Rating'],
  ['店铺资质', 'Store Qualifications'],
  ['店铺收藏', 'Store Favorites'],
  ['店铺优惠券', 'Store Coupons'],
  ['领券中心', 'Coupon Center'],
  ['发票信息', 'Invoice Information'],
  ['发票详情', 'Invoice Details'],
  ['发票类型', 'Invoice Type'],
  ['发票抬头', 'Invoice Title'],
  ['抬头类型', 'Title Type'],
  ['物流详情', 'Logistics Details'],
  ['物流公司', 'Logistics Company'],
  ['物流单号', 'Tracking Number'],
  ['订单信息', 'Order Information'],
  ['付款信息', 'Payment Information'],
  ['配送信息', 'Delivery Information'],
  ['支付方式', 'Payment Method'],
  ['配送方式', 'Delivery Method'],
  ['收货地址', 'Shipping Address'],
  ['收货信息', 'Shipping Info'],
  ['收货人', 'Recipient'],
  ['联系电话', 'Phone'],
  ['用户协议', 'User Agreement'],
  ['隐私政策', 'Privacy Policy'],
  ['立即购买', 'Buy Now'],
  ['立即预定', 'Pre-order Now'],
  ['立即领取', 'Claim Now'],
  ['立即使用', 'Use Now'],
  ['立即评价', 'Review Now'],
  ['立即付款', 'Pay Now'],
  ['立即支付', 'Pay Now'],
  ['立即登录', 'Login Now'],
  ['立即注册', 'Register Now'],
  ['快速登录', 'Quick Login'],
  ['账号登录', 'Account Login'],
  ['登录/注册', 'Login/Register'],
  ['登录弹窗', 'Login Dialog'],
  ['购物车', 'Cart'],
  ['收藏本站', 'Bookmark'],
  ['收藏店铺', 'Follow Store'],
  ['取消收藏', 'Unfollow'],
  ['查看详情', 'View Details'],
  ['查看物流', 'Track Shipment'],
  ['查看订单', 'View Order'],
  ['查看商品', 'View Product'],
  ['进店逛逛', 'Visit Store'],
  ['商户入驻', 'Merchant Settlement'],
  ['资讯信息', 'News'],
  ['手机商城', 'Mobile Mall'],
  ['扫码登录', 'QR Login'],
  ['手机购买', 'Buy on Mobile'],
  ['联系客服', 'Contact Service'],
  ['订单状态', 'Order Status'],
  ['支付状态', 'Payment Status'],
  ['退款信息', 'Refund Information'],
  ['退款原因', 'Refund Reason'],
  ['退款金额', 'Refund Amount'],
  ['退款件数', 'Refund Qty'],
  ['退回商品', 'Return Items'],
  ['申请退款', 'Request Refund'],
  ['确认订单', 'Confirm Order'],
  ['提交订单', 'Place Order'],
  ['提交申请', 'Submit Request'],
  ['全部订单', 'All Orders'],
  ['全部退款', 'All Refunds'],
  ['全部发票', 'All Invoices'],
  ['全部', 'All'],
  ['处理中', 'Processing'],
  ['已处理', 'Processed'],
  ['已开票', 'Issued'],
  ['未开票', 'Not Issued'],
  ['已完成', 'Completed'],
  ['已取消', 'Cancelled'],
  ['已结束', 'Ended'],
  ['未开始', 'Not Started'],
  ['待付款', 'Pending Payment'],
  ['待发货', 'Pending Shipment'],
  ['待收货', 'Pending Receipt'],
  ['待评价', 'Pending Review'],
  ['待审核', 'Pending Review'],
  ['审核通过', 'Approved'],
  ['审核未通过', 'Rejected'],
  ['处理中', 'Processing'],
  ['处理中', 'Processing'],
  ['排序', 'Sort'],
  ['默认', 'Default'],
  ['销量', 'Sold'],
  ['评分', 'Rating'],
  ['价格', 'Price'],
  ['搜索商品', 'Search products'],
  ['搜索', 'Search'],
  ['首页', 'Home'],
  ['我的订单', 'My Orders'],
  ['我的余额', 'My Balance'],
  ['我的积分', 'My Points'],
  ['个人中心', 'Personal Center'],
  ['账户管理', 'Account Settings'],
  ['预售订单', 'Presale Orders'],
  ['售后/退款', 'After-sales/Refund'],
  ['我的收藏', 'My Favorites'],
  ['地址管理', 'Address Management'],
  ['我的优惠券', 'My Coupons'],
  ['入驻记录', 'Settlement Records'],
  ['我的头像：', 'Avatar:'],
  ['我的昵称：', 'Nickname:'],
  ['我的ID：', 'My ID:'],
  ['我的密码：', 'Password:'],
  ['退出登录', 'Log Out'],
  ['人付款', ' paid'],
  ['人关注', ' followers'],
  ['件商品', ' items'],
  ['件', ' pcs'],
  ['满', 'Min '],
  ['可用', ' usable'],
  ['无门槛使用', 'No minimum spend'],
  ['优惠券', 'Coupon'],
  ['优惠', 'Discount'],
  ['优惠价', 'Discount Price'],
  ['运费', 'Shipping'],
  ['库存', 'In Stock'],
  ['数量', 'Quantity'],
  ['金额', 'Amount'],
  ['单价', 'Unit Price'],
  ['操作', 'Action'],
  ['确认', 'Confirm'],
  ['取消', 'Cancel'],
  ['关闭', 'Close'],
  ['删除', 'Delete'],
  ['编辑', 'Edit'],
  ['修改', 'Edit'],
  ['修改密码', 'Change Password'],
  ['修改手机号码', 'Change Phone Number'],
  ['保存', 'Save'],
  ['提交', 'Submit'],
  ['清空', 'Clear'],
  ['选择', 'Select'],
  ['更多', 'More'],
  ['推荐', 'Recommended'],
  ['新品', 'New'],
  ['秒杀', 'Flash Sale'],
  ['自营', 'Self operated'],
  ['店铺', 'Store'],
  ['商品', 'Product'],
  ['订单', 'Order'],
  ['发票', 'Invoice'],
  ['物流', 'Logistics'],
  ['退款', 'Refund'],
  ['余额', 'Balance'],
  ['积分', 'Points'],
  ['支付', 'Payment'],
  ['登录', 'Login'],
  ['注册', 'Register'],
  ['协议', 'Agreement']
]

const localeState = Vue.observable({
  current: DEFAULT_LOCALE
})

function normalizeLocale(locale) {
  const normalized = (locale || '').toLowerCase()
  if (normalized.startsWith('zh')) return 'zh'
  if (normalized.startsWith('en')) return 'en'
  return DEFAULT_LOCALE
}

function hasChinese(text) {
  return ZH_REGEXP.test(text)
}

function translateText(text, locale = localeState.current) {
  const source = typeof text === 'string' ? text : text == null ? '' : String(text)
  if (!source || locale === 'zh' || !hasChinese(source)) return source
  if (exactMessages[source]) return exactMessages[source]

  let translated = source
  let changed = false
  tokenMessages.forEach(([zh, en]) => {
    if (translated.includes(zh)) {
      translated = translated.split(zh).join(en)
      changed = true
    }
  })

  if (!changed) return source

  return translated
    .replace(/《/g, '"')
    .replace(/》/g, '"')
    .replace(/（/g, '(')
    .replace(/）/g, ')')
    .replace(/：/g, ': ')
    .replace(/，/g, ', ')
    .replace(/。/g, '.')
    .replace(/；/g, '; ')
    .replace(/！/g, '!')
    .replace(/？/g, '?')
    .replace(/\s+/g, ' ')
    .trim()
}

function updateElementLocale(locale) {
  ElementLocale.use(locale === 'zh' ? zhLocale : enLocale)
}

function applyHtmlLang(locale) {
  if (process.client) {
    document.documentElement.setAttribute('lang', locale === 'zh' ? 'zh-CN' : 'en')
  }
}

function setPersistedLocale(app, locale) {
  if (process.client) {
    window.localStorage.setItem(STORAGE_KEY, locale)
  }
  app.$cookies.set(COOKIE_KEY, locale, {
    path: '/',
    maxAge: 60 * 60 * 24 * 365
  })
}

function setExplicitLocaleFlag(app) {
  if (process.client) {
    window.localStorage.setItem(EXPLICIT_STORAGE_KEY, '1')
  }
  app.$cookies.set(EXPLICIT_COOKIE_KEY, '1', {
    path: '/',
    maxAge: 60 * 60 * 24 * 365
  })
}

function hasExplicitLocalePreference(app) {
  return Boolean(
    app.$cookies.get(EXPLICIT_COOKIE_KEY) ||
    (process.client && window.localStorage.getItem(EXPLICIT_STORAGE_KEY))
  )
}

function createDomTranslator() {
  const originalTextMap = new WeakMap()
  const attrOriginalMap = new WeakMap()
  const ATTRS = ['placeholder', 'title', 'alt', 'value']

  function translateAttr(el, name) {
    const value = el.getAttribute(name)
    if (!value || !hasChinese(value)) return
    let original = attrOriginalMap.get(el)
    if (!original) {
      original = {}
      attrOriginalMap.set(el, original)
    }
    if (!original[name]) {
      original[name] = value
    }
    const translated = exactMessages[original[name]]
    if (translated) {
      el.setAttribute(name, localeState.current === 'zh' ? original[name] : translated)
    }
  }

  function walk(root) {
    if (!process.client || !root) return
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false)
    let node = walker.nextNode()
    while (node) {
      const value = node.nodeValue
      const parentTag = node.parentElement && node.parentElement.tagName
      if (value && hasChinese(value) && !['SCRIPT', 'STYLE', 'TEXTAREA'].includes(parentTag)) {
        if (!originalTextMap.has(node)) {
          originalTextMap.set(node, value)
        }
        const original = originalTextMap.get(node)
        const translated = exactMessages[original]
        if (translated) {
          node.nodeValue = localeState.current === 'zh' ? original : translated
        }
      }
      node = walker.nextNode()
    }

    if (root.nodeType === 1) {
      if (root.tagName === 'TITLE' && root.textContent) {
        const original = root.dataset.i18nOriginalTitle || root.textContent
        root.dataset.i18nOriginalTitle = original
        root.textContent = localeState.current === 'zh' ? original : (exactMessages[original] || original)
      }
      if (root.hasAttribute) {
        ATTRS.forEach(name => translateAttr(root, name))
      }
      root.querySelectorAll('*').forEach(el => {
        ATTRS.forEach(name => translateAttr(el, name))
      })
    }
  }

  return { walk }
}

export default ({ app }, inject) => {
  const initialLocale = normalizeLocale(
    hasExplicitLocalePreference(app)
      ? (
          app.$cookies.get(COOKIE_KEY) ||
          (process.client && window.localStorage.getItem(STORAGE_KEY)) ||
          DEFAULT_LOCALE
        )
      : DEFAULT_LOCALE
  )

  localeState.current = SUPPORTED_LOCALES.includes(initialLocale) ? initialLocale : DEFAULT_LOCALE
  updateElementLocale(localeState.current)
  applyHtmlLang(localeState.current)

  const domTranslator = process.client ? createDomTranslator() : null

  const api = {
    get locale() {
      return localeState.current
    },
    t(text) {
      return translateText(text, localeState.current)
    },
    setLocale(locale) {
      const nextLocale = normalizeLocale(locale)
      if (!SUPPORTED_LOCALES.includes(nextLocale) || nextLocale === localeState.current) return
      localeState.current = nextLocale
      updateElementLocale(nextLocale)
      applyHtmlLang(nextLocale)
      setExplicitLocaleFlag(app)
      setPersistedLocale(app, nextLocale)
      if (process.client) {
        Vue.nextTick(() => {
          domTranslator && domTranslator.walk(document.body)
          domTranslator && domTranslator.walk(document.head)
        })
      }
    }
  }

  Vue.mixin({
    computed: {
      $locale() {
        return localeState.current
      }
    },
    methods: {
      $setLocale(locale) {
        api.setLocale(locale)
      }
    }
  })

  inject('i18nLite', api)
  inject('tt', api.t)

  if (process.client) {
    setPersistedLocale(app, localeState.current)
    app.router.afterEach(() => {
      Vue.nextTick(() => {
        domTranslator && domTranslator.walk(document.body)
        domTranslator && domTranslator.walk(document.head)
      })
    })
    Vue.nextTick(() => {
      domTranslator && domTranslator.walk(document.body)
      domTranslator && domTranslator.walk(document.head)
    })
  }
}
